import styled from '../../../../../styles/styledComponents/themeComponents';

export const UploadSlotStyle = styled.div`
  .empty-slot {
    width: 180px;
    height: 100px;
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    gap: 6px;
    color: #c0c6d1;
    font-size: 24px;
    transition: all 0.2s;

    &:hover {
      border-color: #1890ff;
      color: #1890ff;
      background: #f0f5ff;
    }

    .upload-text {
      font-size: 12px;
      font-weight: 500;
    }

    .loading-text {
      font-size: 12px;
      color: #999;
    }
  }

  .preview-container {
    position: relative;
    display: inline-block;

    .preview-image {
      width: 360px;
      height: 200px;
      object-fit: contain;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      background: #fafafa;
    }

    .toolbar {
      position: absolute;
      top: 6px;
      right: 6px;
      display: flex;
      gap: 4px;

      .toolbar-btn {
        width: 28px;
        height: 28px;
        border: none;
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        padding: 0;
        transition: background 0.2s;

        &:hover {
          background: rgba(0, 0, 0, 0.7);
        }

        &.delete:hover {
          background: #ff4d4f;
        }
      }
    }
  }
`;
